import { render, staticRenderFns } from "./referralView.vue?vue&type=template&id=2a342e1e"
import script from "./referralView.vue?vue&type=script&lang=js"
export * from "./referralView.vue?vue&type=script&lang=js"
import style0 from "./referralView.vue?vue&type=style&index=0&id=2a342e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports